import React, { useEffect, useState } from "react";
import CommonLayout from "../../Components/CommonLayout/CommonLayout";
import styles from "./dashboard.module.css";
import Card from "../../Components/DashboardComponents/Card/Card";
import { FaRegUser, FaUsers } from "react-icons/fa";
import { MdOutlineStorefront } from "react-icons/md";
import { TbSum, TbTruckDelivery } from "react-icons/tb";
import { CiDeliveryTruck } from "react-icons/ci";
import { GrUndo } from "react-icons/gr";
import { CgArrowsExchange } from "react-icons/cg";
import { FaShopSlash, FaUserXmark } from "react-icons/fa6";
import BarChart from "../../Components/DashboardComponents/BarChart/BarChart";
import { useFetchAll } from "../../custom/FetchApiHook";
import { dashboardApi } from "../../App/api/dashboard.apis";
import CardKPI from "../../Components/DashboardComponents/Card/CardKPI";
import SmallCardKPI from "../../Components/DashboardComponents/Card/SmallCardKPI";

function Dashboard({ meta }) {
  const [pagination, setPagination] = useState({
    filter: {},
  });

  // console.log('meta',meta);
  

  const { value, fetchAllData } = useFetchAll(() =>
    dashboardApi.getOrderAnalytics(pagination ? pagination : {})
  );
  const kpiData = useFetchAll(() => dashboardApi.getKPIData());
  // console.log(value);



  const registerOrderPaymentSummury = [
    {
      heading: "Registered",
      contents: [
        {
          Icon: FaRegUser,
          label: "Users",
          count: kpiData.value?.data?.totalUsers || 0,
        },
        {
          Icon: FaUsers ,
          label: "Customers",
          count: kpiData.value?.data?.totalCustomer || 0,
        },
        {
          Icon: TbTruckDelivery,
          label: "Delivery Man",
          count: kpiData.value?.data?.totalDeliveryMen || 0,
        },
        {
          Icon: MdOutlineStorefront,
          label: "Vendors",
          count: kpiData.value?.data?.totalVendors || 0,
        },
        // {
        //   Icon: LiaCitySolid,
        //   label: "Online Users",
        //   count: 1
        // },
        // {
        //   Icon: LiaCitySolid,
        //   label: "Online Vendors",
        //   count: 1
        // },
        // {
        //   Icon: LiaCitySolid,
        //   label: "Online Deliveryman",
        //   count: 1
        // }
      ],
    },
    {
      heading: "Ordered",
      contents: [
        {
          Icon: TbSum ,
          label: "Total",
          count: kpiData.value?.data?.totalOrders || 0,
        },
        {
          Icon: CiDeliveryTruck,
          label: "Delivered",
          count: kpiData.value?.data?.deliveredOrders || 0,
        },
        {
          Icon: FaUserXmark,
          label: "User Cancelled",
          count: kpiData.value?.data?.userCancelledOrders || 0,
        },
        {
          Icon: FaShopSlash,
          label: "Store Cancelled",
          count: kpiData.value?.data?.storeCancelledOrders || 0,
        },
        {
          Icon: GrUndo ,
          label: "Return",
          count: kpiData.value?.data?.returnedOrders || 0,
        },
        {
          Icon: CgArrowsExchange,
          label: "Replacement",
          count: kpiData.value?.data?.replacementOrders || 0,
        },
      ],
    },
    // {
    //   heading: "Payment Details",
    //   contents: [
    //     {
    //       Icon: FaHandHoldingUsd,
    //       label: "Total",
    //       count: 831
    //     },
    //     {
    //       Icon: FaWallet,
    //       label: "Wallet",
    //       count: 1
    //     },
    //     {
    //       Icon: FaCoins,
    //       label: "Promo",
    //       count: 1
    //     },
    //     {
    //       Icon: BsCashCoin,
    //       label: "Cash",
    //       count: 1
    //     },
    //     {
    //       Icon: RiMoneyDollarCircleFill,
    //       label: "Other",
    //       count: 1
    //     },
    //   ]
    // },
  ];

  const handleFilter = (filter, value) => {
    // console.log("filter", filter);
    // console.log("value", value);
    if (value) {
      setPagination({
        filter: {
          startDate: value[0],
          endDate: value[1],
          // "startDate":moment(value[0]).format("DD-MM-YYYY") ,
          // "endDate":moment(value[1]).format("DD-MM-YYYY")
        },
      });
    }
  };

  useEffect(() => {
    fetchAllData();
  }, [pagination]);

  return (
    <div className="main-content">
      <CommonLayout  NavClass={`-ml-12`}/>
      <div className="d-flex flex-column gap-5">
        <div className={styles.dashboardProgress}>
          <CardKPI  data={registerOrderPaymentSummury[0]} />
          <SmallCardKPI  data={registerOrderPaymentSummury[1]} />
          {/* {registerOrderPaymentSummury.length
            ? registerOrderPaymentSummury.map((data, i) => (
                <CardKPI key={i} data={data} />
              ))
            : ""} */}
        </div>

        {/* <div className={styles.dashboardProgress}>
          {progressData.map(({ left, right }, i) => (<PaymentEarning key={i} left={left} right={right} />))}
        </div> */}
        {/* <LineChart/> */}
        <BarChart data={value} handleFilter={handleFilter} />
        {/* <div className='d-flex gap-1'>
          <PieChart/>
          <MonthBarChart/>
        </div> */}
      </div>
    </div>
  );
}

export default Dashboard;
